import { ItemType } from '~/app/components/order-cancel/orderItems'
import { CategoryType } from '~/__generated__/__types__'

export enum STATUS {
  READY = '',
  COMPLETED = '이용완료',
  CANCEL_COMPLETED = '취소완료',
  CANCEL_REQUESTED = '취소요청중',
}

export enum CANCELLATION_STATUS {
  IN_PROGRESS = '취소요청중',
  COMPLETED = '취소완료',
}

export enum SERVICE_TYPE {
  ACCOMMODATION = '숙소',
  LEISURE = '국내레저',
  TRAIN = '기차',
  BUS = '고속버스',
  TRANSPORTATION = '교통',
  GIFTCARD = '모바일교환권',
}

export const getServiceType = (itemType: ItemType, categoryType?: CategoryType) => {
  // 숙소
  if (itemType === ItemType.ACCOMMODATION) {
    return SERVICE_TYPE.ACCOMMODATION
  }
  // 교통
  if (
    itemType === ItemType.TRAIN ||
    itemType === ItemType.BUS ||
    categoryType === CategoryType.DomesticLeisureRentacar
  ) {
    return SERVICE_TYPE.TRANSPORTATION
  }
  // 모바일교환권
  if (categoryType === CategoryType.DomesticLeisureGiftcard) {
    return SERVICE_TYPE.GIFTCARD
  }
  // 국내레저
  return SERVICE_TYPE.LEISURE
}

export const statusToString = (status?: STATUS | CANCELLATION_STATUS) =>
  status === STATUS.COMPLETED
    ? 'completed'
    : status === STATUS.CANCEL_REQUESTED || status === CANCELLATION_STATUS.IN_PROGRESS
      ? 'cancel-requested'
      : status === STATUS.CANCEL_COMPLETED || status === CANCELLATION_STATUS.COMPLETED
        ? 'cancel-completed'
        : ''
